import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import styleguide from 'styleguide'
import { mediaQueries, withDevice } from '@blazar-plugins/device'

import TabBar from 'components/TabBar'
import Breadcrumbs from 'components/Breadcrumbs'
import ErrorComponent from 'components/ErrorComponent'
import Footer from 'components/Footer'
import { FullHeightWrapper } from 'components/LayoutStyles'

import SelectionList from './SelectionList'

const Container = styled(FullHeightWrapper)`
  justify-content: flex-start;
  flex: 1;
  background-color: ${styleguide.color.extraLightGrey};
`

const Main = styled.main`
  background-color: #fff;

  & > div {
    width: 100%;
    max-width: 980px;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 0 16px;

    @media ${mediaQueries.large} {
      padding: 0 0 16px 0;
    }
  }
`

const BreadcrumbsWrapper = styled.div`
  background-color: #fff;
  & > div {
    @media (min-width: 768px) and (max-width: 992px) {
      padding-left: 16px;
    }
  }
`

const StyledBreadcrumbs = styled(Breadcrumbs)`
  width: 100%;
  max-width: 980px;
  margin: 0 auto;
  box-sizing: border-box;
  padding: 12px 0;
  border-bottom: 1px solid #edefed;
`

export const MediumLayout = ({
  error,
  errorId,
  isFetching,
  firstFetch,
  filterQuery,
  searchParametersDefinition,
  geoPref,
}) => {
  const loading = firstFetch || isFetching

  if (error) {
    return <ErrorComponent error={errorId} />
  }

  return (
    <Container>
      <TabBar />
      <BreadcrumbsWrapper>
        <StyledBreadcrumbs
          filterQuery={filterQuery}
          breadcrumbs={[
            { label: 'Alla', apiQuery: '/classifieds/v2/ads', searchParameters: '' },
            { label: 'Bostad' },
          ]}
          searchParametersDefinition={searchParametersDefinition}
          geoPref={geoPref}
        />
      </BreadcrumbsWrapper>
      <Main>
        <div>
          <SelectionList />
        </div>
      </Main>
      {!loading && <Footer />}
    </Container>
  )
}

MediumLayout.propTypes = {
  error: PropTypes.bool.isRequired,
  errorId: PropTypes.string,
  isFetching: PropTypes.bool.isRequired,
  firstFetch: PropTypes.bool.isRequired,
  cgParameterDefinition: PropTypes.shape({}),
  searchInputActions: PropTypes.shape({
    updateHistory: PropTypes.func.isRequired,
  }),
  device: PropTypes.shape({ is: PropTypes.func.isRequired }).isRequired,
  filterQuery: PropTypes.object,
  searchParametersDefinition: PropTypes.object,
  geoPref: PropTypes.object,
}

export default withDevice(MediumLayout)
